import * as Sentry from '@sentry/react';
import { Navigate } from 'react-router';
import { SEARCH_SPACE_ROUTE } from '@jooxter/core';
import { HomeV2 } from './lazyPages';

/**
 * The landing page of every user (ND-6445). HomeV2 gets its own error boundary: the global one would
 * lock everybody out of the app if it crashed on some data, since every way back leads to `/home`.
 * Instead, the user lands on Spaces and Sentry gets the crash. Each visit to `/home` (navbar "Home",
 * logo…) tries HomeV2 again, and falls back to Spaces again if it still crashes.
 */
export const HomeRoute = () => (
  <Sentry.ErrorBoundary
    fallback={<Navigate to={SEARCH_SPACE_ROUTE} replace />}
    beforeCapture={(scope) => scope.setTag('boundary', 'home-v2')}
  >
    <HomeV2 />
  </Sentry.ErrorBoundary>
);
